import { withMetadata } from '../metadata'
import { searchPhoneNumbersInText as _searchPhoneNumbersInText } from '../../core/index'

export function searchPhoneNumbersInText() {
	return withMetadata(_searchPhoneNumbersInText, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/searchPhoneNumbersInText.js
// module id = Frll
// module chunks = 0 1